<template>
  <div class="bootstrap-wrapper main Bgc-white">
    <Header /> 
    <div class="container">
      <div class="row mt-lg-5 mt-0 error-container">
        <div class="col-lg-12 body p-0 error-container__content">
          <figure class="logo-error">
            <img src="./../../../assets/img/posadas-corporate.svg" alt="Corporate">
          </figure>
          <figure class="error-img">
            <img src="./../../../assets/img/error.svg">
          </figure>

          <div class="error-text-container">
            <p>
                {{$t('language.posadasCorporate.errorPage.mainPaPartOne')}}
               <a class="link" href="mailto:soportecorporate@posadas.com">soportecorporate@posadas.com</a>. 
               {{$t('language.posadasCorporate.errorPage.mainPaPartTwo')}}.
            </p>
            <p>{{$t('language.posadasCorporate.errorPage.secondPa')}}.</p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "../../generales/Header.vue";
  import Footer from "../../generales/Footer.vue";
  export default {
    name: 'Error',
    components: {
      Header,
      Footer,
    },
    data: () => {
      return {
        
      }
    },
    methods: {
    }
  };
</script>

<style lang="scss" scoped>
  @import './../../../assets/scss/config.scss';
  .error-container {
    margin-bottom: 70px;
    padding-top: 50px;
  }
  .error-container__content {
    display: flex;
    flex-direction: column
  }
  .logo-error {
    margin: 0 auto;
    margin-top: 56px;
    margin-bottom: 32px;
    img {
      width: 209px;
    }
  }
  .error-img {
    img {
      width: 100%;
    }
  }
  .error-text-container {
    // width: 90%;
    padding: 0 72px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 50px;
    @media (max-width: 600px) {
      padding: 0 24px;
    }
  }
</style>